
import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import PageTitle from '@/components/PageTitle.vue';

@Component({
  name: 'UserRoute',
  components: {
    PageTitle,
  },
  filters: {
    removeBreakTag(value: string) {
      return value.replace('<br/>', '');
    },
  },
})
export default class LegalMentions extends Vue {
  title: string = 'Parcours utilisateurs';

  key: string = 'userRoute';

  dateFormat(date: any) {
    const cguHistory = this.cgu.lastCguHistory;
    return moment(cguHistory[`${date}Updated`]).format('DD MMMM YYYY');
  }

  get isMobile(): boolean {
    return this.$vuetify.breakpoint.smAndDown;
  }

  get cgu() {
    return this.$store.getters['platform/getPlatform'].config.cgu;
  }

  get userRoute() {
    return this.cgu.userRoute ? this.cgu.userRoute : null;
  }
}
